import { useEffect } from "react";
import { useSelector } from "react-redux";

export default function useHomeLobby() {
  const homeLobbyData = useSelector((state) => state.lobby.homeData);

  if (!homeLobbyData) {
    console.warn("Missing data at homeLobbyData");
    return {};
  }

  return homeLobbyData;
}
